import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Auto-recover from stale dynamic module chunk errors after deployments
window.addEventListener('error', (event) => {
  const isChunkError = 
    event?.message?.includes('Failed to fetch dynamically imported module') ||
    event?.message?.includes('Loading chunk') ||
    event?.message?.includes('Importing a module script failed') ||
    (event?.error && String(event.error).includes('Failed to fetch dynamically imported module'));

  if (isChunkError) {
    const chunkReloadKey = 'chunk_reload_retry';
    const hasReloaded = sessionStorage.getItem(chunkReloadKey);
    if (!hasReloaded) {
      sessionStorage.setItem(chunkReloadKey, 'true');
      window.location.reload();
    }
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reasonStr = String(event?.reason || '');
  if (
    reasonStr.includes('Failed to fetch dynamically imported module') ||
    reasonStr.includes('Loading chunk') ||
    reasonStr.includes('Importing a module script failed')
  ) {
    const chunkReloadKey = 'chunk_reload_retry';
    const hasReloaded = sessionStorage.getItem(chunkReloadKey);
    if (!hasReloaded) {
      sessionStorage.setItem(chunkReloadKey, 'true');
      window.location.reload();
    }
  }
});

window.addEventListener('load', () => {
  setTimeout(() => sessionStorage.removeItem('chunk_reload_retry'), 5000);
});

// Live Terminal Log Streamer Bridge (Streams console logs to npm run logs command prompt)
if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  const origLog = console.log;
  const origInfo = console.info;
  const origWarn = console.warn;
  const origError = console.error;

  let isLogServerAvailable = true;
  let nextRetryTime = 0;

  const sendLogToTerminal = (type: string, ...args: any[]) => {
    const now = Date.now();
    if (!isLogServerAvailable && now < nextRetryTime) {
      return;
    }

    try {
      const message = args.map(arg => {
        if (arg instanceof Error) return `${arg.name}: ${arg.message}\n${arg.stack}`;
        if (typeof arg === 'object') {
          try { return JSON.stringify(arg, null, 2); } catch (_) { return String(arg); }
        }
        return String(arg);
      }).join(' ');

      fetch('http://localhost:9876/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, message, time: new Date().toLocaleTimeString() })
      })
        .then(() => {
          isLogServerAvailable = true;
        })
        .catch(() => {
          isLogServerAvailable = false;
          nextRetryTime = Date.now() + 60000; // Backoff for 60s when log server is offline to prevent ERR_CONNECTION_REFUSED spam
        });
    } catch (_) {}
  };

  console.log = (...args: any[]) => { origLog(...args); sendLogToTerminal('log', ...args); };
  console.info = (...args: any[]) => { origInfo(...args); sendLogToTerminal('info', ...args); };
  console.warn = (...args: any[]) => { origWarn(...args); sendLogToTerminal('warn', ...args); };
  console.error = (...args: any[]) => { origError(...args); sendLogToTerminal('error', ...args); };
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

